import React from "react";
import { WizardStepContext } from "./contextProvider";

function useWizardStepContext() {
  const context = React.useContext(WizardStepContext);

  return context;
}

export default useWizardStepContext;
